const b9mHost = "https://bientot9mois.fr";
/*const traductions = {
  'fr': {
    'size': 'taille',
    'Firstname': 'Prénom',
    'Other names': 'Autres prénoms',
    'Birthdate': 'Date de naissance',
    'Weight / height': 'Poids / taille',
    'Weight': 'Poids',
    'Height': 'Taille',
    'Hour': 'Heure',
    'Background color': 'Couleur de fond',
    'Available Products': 'Modèle',
    'color': 'couleur',
    'Select a color': 'Sélectionner une couleur',
    'Select a font': 'Sélectionner une police',
    'Show': 'Personnaliser',
    'Add To Cart': 'Ajouter au panier',
    'Buy Now': 'Commander',
    'This item has been added to cart!': 'Le produit a été ajouté à votre panier !',
    'View cart': 'Voir mon panier',
    'Error: Some fields are required or invalid data': 'Erreur : certains champs sont manquants ou invalides',
    'This field is required!': 'Ce champ est obligatoire',
    'share': 'partager'
  }
};*/

window.addEventListener("load", (event) => {
  const btnAjoutListe = document.getElementById("ajouter-liste-naissance");
  if (!btnAjoutListe) return;
  
  btnAjoutListe.onclick = function() {
    window.location.href = b9mHost + "/produit/nouveau?lien=" + encodeURI(window.location.href);
  };
});

/*
document.addEventListener("teeinblue-event-component-injected", (event) => {
  hideTemplateHeading();
  
  if (!traductions[document.documentElement.lang]) return; 
  let currentTraductions = traductions[document.documentElement.lang];
  
  translateSize(currentTraductions);
  translateAddToCartButton(currentTraductions);
  
  observeAndTranslateTemplateSubHeadings(currentTraductions);
  observeAndTranslateResponseAndError(currentTraductions);
  observeAndTranslateAddToCartButton(currentTraductions);
});

function hideTemplateHeading() {
  try {
    let title = document.querySelector('.tee-field--template > .tee-field__heading');
    title.style.visibility = 'hidden';
    title.style.height = 0;
  } catch (error) {
    console.error("hideTemplateHeading", error);
  }
}

function observeAndTranslateTemplateSubHeadings(currentTraductions) {
  try {
    translateTemplateSubHeadingsTwice(currentTraductions);
    new MutationObserver(function(mutations) {
      translateTemplateSubHeadingsTwice(currentTraductions);
    }).observe(document.querySelector("#teeFormInputs"), { childList: true, subtree: false });
  } catch (error) {
    console.error("observeAndTranslateTemplateSubHeadings", error);
  }
}

function observeAndTranslateResponseAndError(currentTraductions) {
  try {
    new MutationObserver(function(mutations) {
      translateResponse(currentTraductions);
      translateError(currentTraductions);
    }).observe(document.querySelector("#teeFormActions"), { childList: true, subtree: false });
  } catch (error) {
    console.error("observeAndTranslateResponseAndError", error);
  }
}

function observeAndTranslateAddToCartButton(currentTraductions) {
    new MutationObserver(function(mutations) {
    mutations.forEach((mutation) => {
      for (var i = 0; i < mutation.removedNodes.length; i++) {
          if (mutation.removedNodes[i].classList.contains('tee-spinner')) {
              translateAddToCartButton(currentTraductions);
              break;
          }
      }
    });
  }).observe(document.querySelector("#teeAtcButton"), { childList: true, subtree: false });
}

function translateResponse(currentTraductions) {
  try {
    let response = document.querySelector('.tee-response');
    
    if (!response) return;
    let responseInEnglish = response.innerHTML;
    response.innerHTML = responseInEnglish
      .replace('This item has been added to cart!', currentTraductions['This item has been added to cart!'])
      .replace('View cart', currentTraductions['View cart']);
    
    translateAddToCartButton(currentTraductions);
  } catch (error) {
    console.error("translateResponse", error);
  }

}

function translateError(currentTraductions) {
  try {
      let error = document.querySelector('.tee-error__message > strong');
      if (!error) return;
      error.innerHTML = currentTraductions['Error: Some fields are required or invalid data'];
  } catch (error) {
    console.error("translateError", error);
  }
}

function translateSize(currentTraductions) {
  try {
        document.querySelectorAll('.tee-option__title').forEach(function(element) {
        if (element.textContent.trim() === 'size') {
            element.innerHTML = currentTraductions['size'];
        }
    });
  } catch (error) {
    console.error("translateSize", error);
  }
}

function translateAddToCartButton(currentTraductions) {
  try {
    document.querySelector('#teeAtcButton > span').innerHTML = currentTraductions['Add To Cart'];
    document.querySelector('#teeBuynowButton > span').innerHTML = currentTraductions['Buy Now'];
  } catch (error) {
    console.error("translateAddToCartButton", error);
  }
}

function translateTemplateSubHeadingsTwice(currentTraductions) {
    translateTemplateSubHeadings(currentTraductions);
    setTimeout(function() {
      translateTemplateSubHeadings(currentTraductions);
    }, 1000);
}

function translateTemplateSubHeadings(currentTraductions) {
  try {
     document.querySelectorAll('.tee-available-products .tee-option__title').forEach(function(element) {
        let content = element.textContent.trim();

        if (content === 'Available Products') {
            element.innerHTML = currentTraductions['Available Products'];
        }
    });
    
     document.querySelectorAll('.tee-variants .tee-option__title').forEach(function(element) {
        let content = element.textContent.trim();
        
        if (content === 'color') {
            element.innerHTML = currentTraductions['color'];
        } else if (content === 'size') {
            element.innerHTML = currentTraductions['size'];
        }
    });
    
    document.querySelectorAll('.tee-field__heading > span').forEach(function(element) {
        let content = element.textContent.trim();
        
        if (content === 'Firstname') {
            element.innerHTML = currentTraductions['Firstname'];
        } else if (content === 'Select a color') {
            element.innerHTML = currentTraductions['Select a color'];
        } else if (content === 'Select a font') {
            element.innerHTML = currentTraductions['Select a font'];
        } else if (content === 'Other names') {
            element.innerHTML = currentTraductions['Other names'];
        } else if (content === 'Birthdate') {
            element.innerHTML = currentTraductions['Birthdate'];
        } else if (content === 'Weight / height') {
            element.innerHTML = currentTraductions['Weight / height'];
        } else if (content === 'Weight') {
            element.innerHTML = currentTraductions['Weight'];
        } else if (content === 'Height') {
            element.innerHTML = currentTraductions['Height'];
        } else if (content === 'Background color') {
            element.innerHTML = currentTraductions['Background color'];
        } else if (content === 'Hour') {
            element.innerHTML = currentTraductions['Hour'];
        }
    });
    
    document.querySelectorAll('.tee-visibility-control').forEach(function(element) {
        let label = element.querySelector('.tee-switch__label');
        label.innerHTML = ""; // currentTraductions['Show'] + ' (' + element.previousSibling.querySelector('span:first-child').textContent.trim() + ')';
    });

    document.querySelectorAll('.tee-required-message').forEach(function(element) {
      element.innerHTML = currentTraductions['This field is required!'];
    });
  } catch (error) {
    console.error("translateTemplateSubHeadings", error);
  }
}*/